<template>
  <FormField :half="half">
    <label :for="name">{{ label }}</label>
    <input :id="name" :name="name" :type="type" @input="valueChange" :required="required">
    <FormError :error="error"/>
  </FormField>
</template>

<script>
import {FieldValidationMixin, FormFieldProps} from '@/components/form/fields/mixins'
import {FormError, FormField} from '@/components/form/small'

export default {
  name: 'FormInput',
  mixins: [FieldValidationMixin, FormFieldProps],
  components: {FormError, FormField},
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => ['email', 'tel', 'text'].includes(value)
    }
  }
}
</script>